// context/UpdateSchemaContext.tsx
import React, { createContext, useContext, useState } from 'react'
import { useUpdateSchema } from 'utils/hooks/queries/useUpdateSchema'

type UpdateSchemaContextType = ReturnType<typeof useUpdateSchema>

const UpdateSchemaContext = createContext<UpdateSchemaContextType | undefined>(undefined)

const UpdateSchemaProvider = ({ children }: { children: React.ReactNode }) => {
  const mutation = useUpdateSchema()
  return <UpdateSchemaContext.Provider value={mutation}>{children}</UpdateSchemaContext.Provider>
}

const useUpdateSchemaContext = () => {
  const context = useContext(UpdateSchemaContext)
  if (!context) {
    throw new Error('useUpdateSchemaContext must be used within UpdateSchemaProvider')
  }
  return context
}

export { useUpdateSchemaContext, UpdateSchemaProvider }
